import { NgModule } from '@angular/core'

import { SharedModule } from '../shared/shared.module'

import { NotificationComponent } from './notification.component'
import { NotificationFactoryComponent } from './notification-factory/notification-factory.component'

import { NotificationService } from './shared/notification.service'


@NgModule({
  imports: [
    SharedModule
  ],
  exports: [
    NotificationFactoryComponent
  ],
  declarations: [
    NotificationComponent,
    NotificationFactoryComponent
  ],
  providers: [
    NotificationService
  ]
})
export class NotificationModule { }


export { NotificationService }



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/notification/notification.module.ts